import React from 'react';

import Modal from 'react-bootstrap/Modal';
import Tooltip from '../../components/Tooltip';

import closeIcon from '../../assets/images/closeIcon.svg';

import FilledButton from '../../components/Buttons/FilledButton';
import classes from './styles.module.scss';

export default function SelectShareOptionModal({
  show,
  handleClose,
  openRequestReviewModal,
  openShareMeetingModal,
}) {
  return (
    <Modal
      show={show}
      centered
      contentClassName={classes.SelectShareOptionModal}
      dialogClassName={classes.dialog}
      backdropClassName={classes.backdrop}
    >
      <i className={classes.closeIcon} onClick={handleClose}>
        <img src={closeIcon} alt="Close" />
      </i>
      <div className={classes.content}>
        <h3>What do you want to do?</h3>
        <div className={classes.buttons}>
          <Tooltip
            position="top-right"
            text="Share your SOP video with others to review and approve content"
          >
            <div>
              <FilledButton
                onClick={openRequestReviewModal}
                width={270}
                style={{ whiteSpace: 'noWrap' }}
              >
                Send for Review
              </FilledButton>
            </div>
          </Tooltip>
          <Tooltip
            position="top-right"
            text="View or update who has access to this video"
          >
            <div>
              <FilledButton
                onClick={openShareMeetingModal}
                width={270}
                style={{ whiteSpace: 'noWrap' }}
                color="#111"
              >
                Manage access
              </FilledButton>
            </div>
          </Tooltip>
        </div>
      </div>
    </Modal>
  );
}
